function fn_part_detail_area() {
    var part_detail_area = ".part-detail-area";
    if ($(part_detail_area).length) {
        nl_fn_switch_content(part_detail_area,1);
    }
}